import axios from 'axios';

const url = process.env.NODE_ENV === 'development' ? 'http://localhost:7709/api/' : 
                                                     'https://gestao.siscor.com.br/portalrh_v2/api/';

const instance = axios.create({
    baseURL: url
});

export default instance;